import axios from "axios";
import Swal from "sweetalert2";

const handleMultipleWasteInventory = async (
  wasteItems,
  token,
  onSuccess,
  onFail
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/v1/api/inventory/waste-multiple`,
      { items: wasteItems },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    Swal.fire({
      icon: "success",
      title: "Waste Recorded",
      text: response.data.message || "Menu waste successfully logged.",
    });

    if (onSuccess) onSuccess();
  } catch (error) {
    console.error("Error logging multiple menu waste:", error);
    Swal.fire({
      icon: "error",
      title: "Waste Error",
      text:
        error.response?.data?.message ||
        "An error occurred while recording waste.",
    });
    if (onFail) onFail();
  }
};

export default handleMultipleWasteInventory;
